import {
    RETRIEVE_STORAGE_TYPES,
    CREATE_STORAGE_TYPE,
    UPDATE_STORAGE_TYPE,
    DELETE_STORAGE_TYPE,
    RESTORE_STORAGE_TYPE,
    UPDATE_STORAGE_TYPE_STATUS,
} from "./types";
  
import promoCodesService from "../services/promoCodes.service";

export const retrievePromoCodes = (keyword = '', page = '', perPage = '', all = true, active = true) => async (dispatch) => {
  try {
    const res = await promoCodesService.getAll(keyword, page, perPage, all, active);
    dispatch({
      type: RETRIEVE_STORAGE_TYPES,
      payload: res.data.promoCodes,
    });
  } catch (err) {
    console.log(err);
  }
};

export const createPromoCode = (data) => async (dispatch) => {
  try {
    const res = await promoCodesService.create(data);

    dispatch({
      type: CREATE_STORAGE_TYPE,
      payload: res.data.promoCodeInfo,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updatePromoCode = (id, data) => async (dispatch) => {
  try {
    const res = await promoCodesService.update(id, data);

    dispatch({
      type: UPDATE_STORAGE_TYPE,
      payload: res.data.promoCodeInfo
      ,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updatePromoCodeStatus = (id, data) => async (dispatch) => {
  try {
    const res = await promoCodesService.updateStatus(id, data);

    dispatch({
      type: UPDATE_STORAGE_TYPE_STATUS,
      payload: res.data.promoCodes,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const deletePromoCode = (id, data) => async (dispatch) => {
  try {
    const res = await promoCodesService.deletePromoCode(id, data);

    dispatch({
      type: DELETE_STORAGE_TYPE,
      payload: res.data.promoCodes,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const restorePromoCode = (id, data) => async (dispatch) => {
  try {
    const res = await promoCodesService.restore(id, data);

    dispatch({
      type: RESTORE_STORAGE_TYPE,
      payload: res.data.promoCodes,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};